export function table(ctx, node) {
    ln(node)
    xf(ctx, node);
    Ef(ctx, node)
}

function ln(t) {
    t.isFirstTime = !0;
    Cf(t)
}

function Cf(t) {
    const e = [], i = [];
    t.rowHeight || (t.rowHeight = 40);
    t.colWidth || (t.colWidth = 150);
    let o = 0;
    const s = t.styles.filter(
        function(c){c.col !== void 0 && c.row === void 0 && c.width} 
    );
    let r = {};
    s.forEach(function(c) {
        r[c.col] = c.width
    });
    for (let c = 0; c < t.data[0].length; c++){
        o += r[c] || t.colWidth;
        e.push(o);
    } 
    let n = 0;
    const l = t.styles.filter(
        function(c){ 
            c.col === void 0 && c.row !== void 0 && c.height
        }
    );
    let a = {};
    l.forEach(function(c){
        a[c.row] = c.height
    });
    for (let c = 0; c < t.data.length; c++){
        n += a[c] || t.rowHeight;
        i.push(n);
    } 
    t.colPos = e;
    t.rowPos = i;
    t.tableWidth = o;
    t.tableHeight = n;
    t.width = o;
    t.height = n,
    t.rect.height=t.height;
    t.rect.width=t.width;
    St(t.rect)
}

function St(t) {
    t.ex = t.x + t.width, t.ey = t.y + t.height
}

function xf(t, e) {
    if (!e.colPos)
        return;
    const i = e.rect;
    t.save(),
    t.strokeStyle = e.color,
    t.beginPath(),
    t.rect(i.x, i.y, i.width, i.height),
    e.background && (t.fillStyle = e.background,
    t.fill()),
    t.stroke();
    let o = e.rowPos[e.rowPos.length - 1];
    for (const s of e.rowPos) {
        if (s === o)
            continue;
        const r = s * e.rect.height / e.tableHeight;
        t.beginPath(),
        t.moveTo(e.rect.x, e.rect.y + r),
        t.lineTo(e.rect.ex, e.rect.y + r),
        t.stroke()
    }
    o = e.colPos[e.colPos.length - 1],
    e.colPos.forEach((s,r)=>{
        if (s === o)
            return;
        const n = s * e.rect.width / e.tableWidth;
        t.beginPath(),
        t.moveTo(e.rect.x + n, e.rect.y),
        t.lineTo(e.rect.x + n, e.rect.ey),
        t.stroke()
    }),
    t.restore()
}
function un(t, e, i) {
    const o = t.rect.width / t.tableWidth
      , s = t.rect.height / t.tableHeight;
    let r = 0
      , n = t.colPos[i] * o;
    i > 0 && (r = t.colPos[i - 1] * o);
    let l = 0
      , a = t.rowPos[e] * s;
    return e > 0 && (l = t.rowPos[e - 1] * s),
    {
        x: t.rect.x + r,
        y: t.rect.y + l,
        ex: t.rect.x + n,
        ey: t.rect.y + a,
        width: n - r,
        height: a - l
    }
}
function hn(t, e, i) {
    if (!t.data || !Array.isArray(t.data)) return;
    const o = t.data[e], s = t.styles.filter(function(r){r.row === e && r.col === i});
    if (Array.isArray(o)) return {
        value: o[i],
        style: s.length > 0 ? s[0] : {}
    };
    if (!o.data || !Array.isArray(o.data)) return
}
function Ti({
    fontStyle: t = "normal",
    textDecoration: e = "normal",
    fontWeight: i = "normal",
    fontSize: o = 12,
    fontFamily: s = "Arial",
    lineHeight: r = 1
} = {}) {
    return` $ {
        t
    }
    $ {
        e
    }
    $ {
        i
    }
    $ {
        o
    }
    px / $ {
        r
    }
    $ {
        s
    }`
}
function vs(t, e) {
    //var i = e.canvas;
    //var  o = i.getContext("2d"); 
    var s=e.fontStyle;
    var r=e.fontWeight;
    var n=e.fontSize;
    var l=e.fontFamily;
    var a=e.lineHeight;
    //o.save();
    const c = [];
    let h = t[0] || "";
    for (let u = 1; u < t.length; ++u) {
        const d = t[u] || "", v = h + d;
        let m = 0;
       /* if (i.measureTextWidth) o.font = Ti({
            fontStyle: s,
            fontWeight: r,
            fontFamily: l || i.fontFamily,
            fontSize: n,
            lineHeight: a
        }), m = o.measureText(v).width;
        else {*/
            const p = v.match(/[^\x00-\xff]/g) || "", b = p.length * n, k = v.match(/\s/g) || "", P = k.length * n * .3, _ = (v.length - p.length - k.length) * n * .6;
            m = b + P + _
        //}
        const g = e.rect.width;
        m <= g ? h += d : (h.length && c.push(h), h = d)
    }
    return h.length && c.push(h), c
}
function Ni(t) {
    t[t.length - 1] = t[t.length - 1].slice(0, -3) + "..."
}
function Ne(t, e = t.text) {
    if (e == null) {
        t.textLines = [];
        return
    }
    e = e.toString();
    let i = [];
    const o = t.fontSize * t.lineHeight, s = t.rect.height, r = Math.floor(s / o), n = r > 1 ? r : 1;
    switch (t.whiteSpace) {
        case "nowrap":
            if (t.ellipsis !== !1) {
                const h = vs(e.split(""), t);
                i.push(h[0]), h.length > 1 && Ni(i)
            } else i.push(e);
            break;
        case "pre-line":
            i = e.split(/[\n]/g), t.ellipsis !== !1 && i.length > n && (i = i.slice(0, n), Ni(i));
            break;
        case "break-all":
        default:
            const a = e.split(/[\n]/g);
            let c = 0;
            t: for (const h of a) {
                const u = t.whiteSpace === "break-all" ? h.split("") : br(h);
                let d = vs(u, t);
                if (d.length === 0 && (d = [""]), t.ellipsis != !1)
                    for (const v of d)
                        if (c++, c > n) {
                            Ni(i);
                            break t
                        } else i.push(v);
                        else i.push(...d)
            }
            break
    }
    const l = t.keepDecimal;
    return l != null && i.forEach(function(a, c){
        const h = Number(a);
        isNaN(h) || (i[c] = h.toFixed(l))
    }), t.textLines = i, i
}
function br(t = "") {
    const e = [];
    let i = "";
    for (let o = 0; o < t.length; ++o) {
        const s = t.charCodeAt(o);
        s < 33 || s > 126 ? (i && (e.push(i), i = ""), e.push(t[o])) : i += t[o]
    }
    return i && e.push(i), e
}
function Ef(t, e) {
    //e.canvas=t.canvas
    var o, s, r, n;
    if (!e.colPos)
        return;
    /*e.texts || */(e.texts = []);
    const i = 1;
    for (let l = 0; l < e.rowPos.length; l++)
        for (let a = 0; a < e.colPos.length; a++) {
            let {value: c, style: h} = hn(e, l, a)
              , u = !0;
            h.wheres && Array.isArray(h.wheres) && (u = !1,
            u = h.wheres.every(function(b) {
                return new Function("attr",`return attr ${b.comparison} ${b.value}`)(c)
            }));
            let d = e.color
              , v = null;
            u && (d = h.color || e.color,
            v = h.background);
            let m;
            ((o = e.activeCell) == null ? void 0 : o.row) === l && ((s = e.activeCell) == null ? void 0 : s.col) === a && (d = e.activeColor,
            v = e.activeBackground,
            m = d),
            ((r = e.hoverCell) == null ? void 0 : r.row) === l && ((n = e.hoverCell) == null ? void 0 : n.col) === a && (d = e.hoverColor,
            v = e.hoverBackground,
            m = d);
            const g = un(e, l, a);
            v && (t.save(),
            t.fillStyle = v,
            t.fillRect(g.x, g.y, g.width, g.height),
            t.restore()),
            m && (t.save(),
            t.strokeStyle = m,
            t.strokeRect(g.x, g.y, g.width, g.height),
            t.restore()),
            e.textRect = g;
            let p = e.texts[l];
            if (e.texts[l] || (p = [],
            e.texts.push(p)),
            p[a] == null) {
                if (typeof c == "object") {
                    const b = e.styles.filter(k=>k.col === a && k.row === void 0 && k.pens);
                    if (b.length > 0) {
                        if (p[a] = "",
                        e.isFirstTime) {
                            let k = JSON.parse(JSON.stringify(b[0].pens));
                            k.forEach(P=>{
                                Object.assign(P, {
                                    row: l,
                                    col: a
                                })
                            }
                            ),
                            Df(e, g, k),
                            e.canvas.parent.pushChildren(e, k)
                        }
                        continue
                    }
                } else
                    c === void 0 ? p[a] = "" : p[a] = c.text || c + "";
                if (!p[a])
                    continue;
                p[a] = Ne(e, p[a])
            }
            if (!!p[a]) {
                if (t.save(),
                t.fillStyle = d,
                t.textAlign = "center",
                t.textBaseline = "middle",
                t.font = (e.fontStyle || "") + " normal " + (e.fontWeight || "") + " " + (e.fontSize || 12) * i + "px " + e.fontFamily,
                p[a].length === 1)
                    t.fillText(p[a][0], g.x + g.width / 2, g.y + g.height / 2);
                else {
                    const k = e.fontSize * e.lineHeight * i
                      , P = p[a].length * k;
                    let _ = (g.height - P) / 2;
                    p[a].forEach((E,S)=>{
                        t.fillText(E, g.x + g.width / 2, g.y + _ + (S + .55) * k)
                    }
                    )
                }
                t.restore()
            }
        }
}